var map = {
	"./accounts/api/getAllCreditNoteTransaction.graphql": "6da5",
	"./accounts/api/getAllInvoiceTransaction.graphql": "840a",
	"./accounts/api/getAppConfigurations.graphql": "cf71",
	"./accounts/api/getInvoiceById.graphql": "a33b",
	"./accounts/api/updateConfigurations.graphql": "0ffe",
	"./appointments/api/getAllActiveAppoinments.graphql": "afca",
	"./appointments/api/getAllActiveAppoinmentsByUserID.graphql": "a9b7",
	"./appointments/api/getAllAppoinments.graphql": "cf44",
	"./appointments/api/getAllClosedAppoinments.graphql": "8a05",
	"./appointments/api/updateAppointment.graphql": "a0d1",
	"./audit-trial-log/api/getAllAuditTrialByAuditType.graphql": "d4a2",
	"./audit-trial-log/api/getAllPlanSwitchErrors.graphql": "de19",
	"./celebrity/api/addReferralTransaction.graphql": "9440",
	"./celebrity/api/assignPackageToCelebrity.graphql": "d6c3",
	"./celebrity/api/createCelebrity.graphql": "0094",
	"./celebrity/api/deleteCelebrity.graphql": "8930",
	"./celebrity/api/getAllCelebrity.graphql": "45f4",
	"./celebrity/api/getAllCelebrityPackages.graphql": "c79b",
	"./celebrity/api/getAllReferralTransactionsByUser.graphql": "391a",
	"./celebrity/api/getCelebrityById.graphql": "5ba4",
	"./celebrity/api/removePackageFromCelebrity.graphql": "6234",
	"./celebrity/api/totalReferralTransactionAmountByUser.graphql": "ba82",
	"./celebrity/api/updateCelebrity.graphql": "6cc3",
	"./contact-method/api/createContactMethod.graphql": "03fd",
	"./contact-method/api/deleteContactMethod.graphql": "a50b",
	"./contact-method/api/getAllContactMethods.graphql": "cfdc",
	"./contact-method/api/updateContactMethod.graphql": "2ab9",
	"./core/api/getAlertQuantity.graphql": "7ebb",
	"./core/api/getCustomersByDay.graphql": "2ca2",
	"./core/api/getCustomersByMonth.graphql": "8ce1",
	"./core/api/getDeliveryStatusCount.graphql": "b4c5",
	"./core/api/getOrdersByDay.graphql": "b5f7",
	"./core/api/getOrdersByMonth.graphql": "c280",
	"./core/api/getPackageCount.graphql": "5d82",
	"./core/api/getSalesTrendGraph.graphql": "b450",
	"./core/api/getTrendingMealCount.graphql": "bf28",
	"./core/api/hardDeleteUser.graphql": "1a02",
	"./customer/api/addCustomerAllergy.graphql": "8b2f",
	"./customer/api/addCustomerDislike.graphql": "fb60",
	"./customer/api/adminCheckoutCustomerPackage.graphql": "3eb9",
	"./customer/api/adminChooseCustomerMenu.graphql": "25ce",
	"./customer/api/adminCustomerSignUp.graphql": "f360",
	"./customer/api/birthdayReport.graphql": "fa77",
	"./customer/api/confirmModifiedPackagePayment.graphql": "96af",
	"./customer/api/createAppointment.graphql": "c7cf",
	"./customer/api/createArea.graphql": "fada",
	"./customer/api/createBlock.graphql": "7de8",
	"./customer/api/createDeliverySchedule.graphql": "f500",
	"./customer/api/createShift.graphql": "dee8",
	"./customer/api/createTempCustomerSalesorder.graphql": "86c7",
	"./customer/api/createZone.graphql": "b6fb",
	"./customer/api/customerSignUp.graphql": "e482",
	"./customer/api/customerTags.graphql": "531b",
	"./customer/api/customers.graphql": "5f99",
	"./customer/api/deleteArea.graphql": "aed2",
	"./customer/api/deleteBlock.graphql": "34c0",
	"./customer/api/deleteCustomer.graphql": "4ee2",
	"./customer/api/deleteCustomerDislike.graphql": "37a4",
	"./customer/api/deleteDeliverySchedule.graphql": "2392",
	"./customer/api/deleteDietitianAppointment.graphql": "3cae",
	"./customer/api/deleteShift.graphql": "f2ba",
	"./customer/api/deleteZone.graphql": "116f",
	"./customer/api/freezeCustomerMenu.graphql": "152d",
	"./customer/api/getAllActiveDietitianAppoinments.graphql": "95a1",
	"./customer/api/getAllAppoinments.graphql": "e596",
	"./customer/api/getAllAreas.graphql": "313b",
	"./customer/api/getAllBlocks.graphql": "af28",
	"./customer/api/getAllCategoryWiseMenu.graphql": "d222",
	"./customer/api/getAllCustomerBasicInfo.graphql": "6132",
	"./customer/api/getAllCustomerRating.graphql": "734b",
	"./customer/api/getAllDietitianAppointments.graphql": "15ed",
	"./customer/api/getAllDriverShifts.graphql": "6c09",
	"./customer/api/getAllPhoneVerifications.graphql": "31ed",
	"./customer/api/getAllShifts.graphql": "0d5f",
	"./customer/api/getAllUsers.graphql": "d491",
	"./customer/api/getAllZones.graphql": "baf5",
	"./customer/api/getAreaByRegion.graphql": "a4b0",
	"./customer/api/getBlocksByArea.graphql": "cc7c",
	"./customer/api/getCustomerById.graphql": "0fc6",
	"./customer/api/getCustomerDetailByCreatedDate.graphql": "4a14",
	"./customer/api/getCustomersTempPackages.graphql": "74c1",
	"./customer/api/getDeliveryScheduleByCustomerId.graphql": "e9bc",
	"./customer/api/getShiftsByArea.graphql": "4bda",
	"./customer/api/pauseCustomerMenu.graphql": "189d",
	"./customer/api/queries/isLocationInServingArea.graphql": "a892",
	"./customer/api/recheckAppointmentPaymentStatus.graphql": "6f73",
	"./customer/api/regenerateAppointmentInvoiceUrl.graphql": "87bf",
	"./customer/api/removeCustomerAllergy.graphql": "330e",
	"./customer/api/resetPassword.graphql": "927d",
	"./customer/api/selectByCustomer.graphql": "ba68",
	"./customer/api/unpauseCustomerMenu.graphql": "3e04",
	"./customer/api/updateArea.graphql": "6569",
	"./customer/api/updateBlock.graphql": "2ad3",
	"./customer/api/updateCustomer.graphql": "a44f",
	"./customer/api/updateCustomerSalesorder.graphql": "e8b3",
	"./customer/api/updateDietitianAppointment.graphql": "711a",
	"./customer/api/updateDietitianAppt.graphql": "83d8",
	"./customer/api/updateShift.graphql": "3d68",
	"./customer/api/updateZone.graphql": "84a3",
	"./customer/components/salesOrder/api/customerGetAllCelebrities.graphql": "5cf6",
	"./customer/components/salesOrder/api/getMealSelectionDate.graphql": "abcb",
	"./customer/components/salesOrder/api/reCalculateEndDate.graphql": "dbe3",
	"./customer/components/salesOrder/api/recheckPaymentStatus.graphql": "927f",
	"./customer/components/salesOrder/api/recheckSalesOrderEditPaymentStatus.graphql": "30fe",
	"./customer/components/salesOrder/api/regenerateInvoiceUrl.graphql": "78ce",
	"./customer/components/salesOrder/api/regenerateSalesOrderInvoiceUrl.graphql": "930a",
	"./customer/components/salesOrder/api/updateSalesOrderToExpire.graphql": "1928",
	"./delivery/api/generateDeliveryReport.graphql": "d63c",
	"./delivery/api/getCustomerByCustomerUniqueId.graphql": "6e13",
	"./delivery/api/getDeliveryDetails.graphql": "4890",
	"./delivery/api/getDeliveryDetailsByDate.graphql": "d97a",
	"./delivery/api/getInstantViewDeliveryDetailsByDate.graphql": "9556",
	"./delivery/api/isAllowToGenerateReport.graphql": "6c65",
	"./delivery/api/updateDeliveryStatus.graphql": "9962",
	"./dietitian/api/checkDietitianPaymentStatus.graphql": "d2c2",
	"./dietitian/api/createDietitian.graphql": "3ceb",
	"./dietitian/api/deleteDietitian.graphql": "5db5",
	"./dietitian/api/getAllActiveAppoinmentsByDietitian.graphql": "414f",
	"./dietitian/api/getAllAppoinmentsByDietitian.graphql": "5c40",
	"./dietitian/api/getAllDietitians.graphql": "0cf8",
	"./dietitian/api/getDietitianById.graphql": "08de",
	"./dietitian/api/updateDietitian.graphql": "fd2c",
	"./faq/api/createFaq.graphql": "a99e",
	"./faq/api/deleteFaq.graphql": "2aeb",
	"./faq/api/getAllFaqs.graphql": "b027",
	"./faq/api/updateFaq.graphql": "726c",
	"./managers/api/createManager.graphql": "7d44",
	"./managers/api/deleteManager.graphql": "8413",
	"./managers/api/getAllManagers.graphql": "0545",
	"./managers/api/getManagerById.graphql": "30af",
	"./managers/api/updateManager.graphql": "a71e",
	"./menu-packages/api/checkCustomersBeforeMealDeactivate.graphql": "17eb",
	"./menu-packages/api/createCategory.graphql": "2a9d",
	"./menu-packages/api/createMenuItem.graphql": "0c40",
	"./menu-packages/api/createPackages.graphql": "d21a",
	"./menu-packages/api/deleteCategory.graphql": "d770",
	"./menu-packages/api/deleteMenuItem.graphql": "d5d5",
	"./menu-packages/api/deletePackages.graphql": "37cd",
	"./menu-packages/api/getAllCUstomerTags.graphql": "7537",
	"./menu-packages/api/getAllCategories.graphql": "c425",
	"./menu-packages/api/getAllCustomersUsingMealByDate.graphql": "307d",
	"./menu-packages/api/getAllMealsTags.graphql": "a765",
	"./menu-packages/api/getAllMenuItems.graphql": "b36a",
	"./menu-packages/api/getAllMenuItemsBasic.graphql": "8731",
	"./menu-packages/api/getAllPackages.graphql": "6dce",
	"./menu-packages/api/getAllPackagesWithChoice.graphql": "1774",
	"./menu-packages/api/getNewMealCode.graphql": "2a33",
	"./menu-packages/api/getPackageById.graphql": "454b",
	"./menu-packages/api/updateCategory.graphql": "0f69",
	"./menu-packages/api/updateCustomerTag.graphql": "6547c",
	"./menu-packages/api/updateMealsTag.graphql": "fac4",
	"./menu-packages/api/updateMenuItem.graphql": "a8927",
	"./menu-packages/api/updatePackages.graphql": "5210",
	"./menu-packages/diet-plan/api/createDietPlan.graphql": "dead",
	"./menu-packages/diet-plan/api/deleteDietPlan.graphql": "59b0",
	"./menu-packages/diet-plan/api/getAllDietPlans.graphql": "8ffb",
	"./menu-packages/diet-plan/api/updateDietPlan.graphql": "09a4",
	"./notifications/api/createNotification.graphql": "6286",
	"./notifications/api/getAllNotifications.graphql": "c0f2",
	"./offer/api/createOffer.graphql": "11a4",
	"./offer/api/deleteOffer.graphql": "37f7",
	"./offer/api/getAllOffers.graphql": "269f",
	"./offer/api/updateOffer.graphql": "a925e",
	"./orders/api/getAllSubscribedPackages.graphql": "f0f7",
	"./orders/api/getAllSubscribedPackagesWithDate.graphql": "1d7a",
	"./orders/api/getIngredientDetailsByDate.graphql": "7873",
	"./orders/api/getOrderMealDetailsByDate.graphql": "4e8a",
	"./permission/api/createUserRole.graphql": "cfe0",
	"./permission/api/deleteUserRoleById.graphql": "9678",
	"./permission/api/getAllUserRole.graphql": "1d79",
	"./permission/api/getUserRolePermission.graphql": "f20c",
	"./permission/api/updateUserRolePermission.graphql": "a75b",
	"./plan-switch/api/createPlanSwitch.graphql": "e1a0",
	"./plan-switch/api/deletePlanSwitch.graphql": "6d6f",
	"./plan-switch/api/getAllPlanSwitches.graphql": "ab95",
	"./plan-switch/api/groupPlanSwitch.graphql": "7cd5",
	"./plan-switch/api/swapPlanSwitch.graphql": "7247",
	"./plan-switch/api/switchAllCustomerPlans.graphql": "5056",
	"./promotion/api/createPromoCode.graphql": "98cb",
	"./promotion/api/deletePromoCode.graphql": "d6f9",
	"./promotion/api/getAllPromoCodes.graphql": "ea9c",
	"./promotion/api/getPromoCodeById.graphql": "1bc7",
	"./promotion/api/updatePromoCode.graphql": "0f1d",
	"./referral-transactions/api/getAllReferralTransactions.graphql": "de81",
	"./region/api/createRegion.graphql": "ac88",
	"./region/api/deleteRegion.graphql": "7d09",
	"./region/api/getAllRegions.graphql": "dd51",
	"./region/api/updateRegion.graphql": "513a",
	"./reports/api/createDriver.graphql": "925f",
	"./reports/api/deleteDriver.graphql": "d076",
	"./reports/api/getAllDrivers.graphql": "0d48",
	"./reports/api/getDriverReport.graphql": "3d3a",
	"./reports/api/getPausedMealsDetailsByDate.graphql": "9d12",
	"./reports/api/getPromocodeReport.graphql": "102f",
	"./reports/api/updateDriver.graphql": "2df8",
	"./sales/api/getSalesReport.graphql": "aaa5",
	"./settings/api/getAppConfigurations.graphql": "536d",
	"./settings/api/getPolicy.graphql": "012c",
	"./settings/api/getPushNotification.graphql": "3011",
	"./settings/api/getTutorial.graphql": "7f6f",
	"./settings/api/getUser.graphql": "eb15",
	"./settings/api/updateConfigurations.graphql": "8abf",
	"./settings/api/updatePassword.graphql": "83c1",
	"./settings/api/updatePolicy.graphql": "93bd",
	"./settings/api/updatePushNotification.graphql": "34e6",
	"./settings/api/updateTutorial.graphql": "7833",
	"./settings/api/updateUser.graphql": "d67b",
	"./stock/api/adjustStock.graphql": "8499",
	"./stock/api/createIngredient.graphql": "7f75",
	"./stock/api/createPurchase.graphql": "e180",
	"./stock/api/deleteIngredient.graphql": "94a0",
	"./stock/api/deletePurcahse.graphql": "bd57",
	"./stock/api/getAllCurrentStocks.graphql": "7a39",
	"./stock/api/getAllDislikableIngredients.graphql": "3f03",
	"./stock/api/getAllIngredients.graphql": "d043",
	"./stock/api/getAllMealIngredients.graphql": "1169",
	"./stock/api/getAllPurchases.graphql": "ee82",
	"./stock/api/getAllStockAdjust.graphql": "4eed",
	"./stock/api/getAllStocks.graphql": "88b2",
	"./stock/api/getIngredientCurrentStock.graphql": "cc24",
	"./stock/api/getNewIngredientCode.graphql": "db9c",
	"./stock/api/updateIngredient.graphql": "d7d2",
	"./stock/api/updatePurchase.graphql": "0b1b",
	"./universal-pause/api/createUniversalPause.graphql": "b560",
	"./universal-pause/api/deleteUniversalPause.graphql": "9813",
	"./universal-pause/api/getAllUniversalPause.graphql": "3cfe",
	"./user/api/getDashboardData.graphql": "ce1e",
	"./user/api/getTodayCustomerBirthdays.graphql": "3968",
	"./user/api/signin.graphql": "05b3",
	"./user/api/user_fragment.graphql": "1d17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dca3";